import http, { API_CORE } from '../http';

export default function ProductUpdateExcelService() {
  const uploadFiles = async (params) => {
    const response = await http(API_CORE).post('/product-update-excel', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  };

  return {
    uploadFiles: uploadFiles,
  };
}
